var Toolbar = require('./toolbar');
var Preview = require('./preview');
var Administration = require('./administration');
var $ = require('jquery');

var mobilepreview = require('diy/mobilepreview/mobilepreview');

$(document).ready(function() {
    if (window.diy && window.diy.context && !window.diy.context.isPublicView) {
        // Used in mobilepreview php view
        diy.core.namespace('diy.editor').mobilepreview = mobilepreview;

        var toolbar = new Toolbar();

        mobilepreview.setToolbar(toolbar);

        toolbar.Administration = new Administration(toolbar);
        toolbar.Preview = new Preview(toolbar);
    }
});



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/toolbar/init-mobilePreview.js
 ** module id = 0
 ** module chunks = 9
 **/